import { BodyText } from '@paypalcorp/pp-react'
import { merge } from 'lodash-es'
import PageMessage from 'ppbl/components/PageMessage'
import clientLogger from 'ppbl/utils/client-logger'
import { redirectToServerRoute } from 'ppbl/utils/common-utils'
import { trackClick, trackPage } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import React, { useEffect } from 'react'

const fptiData = {
  page: 'countryNotSupportedPage',
  event_name: FPTI_EVENTS.PAGE.COUNTRY_NOT_SUPPORTED,
}

type Props = {
  applicationType: string
}

const CountryNotSupportedPage: React.FC<Props> = ({ applicationType }) => {
  useEffect(() => {
    clientLogger.info(
      `Country Not Supported Page is Loaded: User account is not supported - Application type is ${applicationType}`,
    )
    trackPage(fptiData)
  }, [])

  const onclick = () => {
    trackClick(
      merge(fptiData, {
        component: 'restartApplication_button',
        link: 'restartApplication_button',
      }),
    )
    redirectToServerRoute(
      `/merchant-lending/loanbuilder/${applicationType}/start`,
    )
  }

  return (
    <PageMessage
      id="unSupportedPageMessage"
      type="error"
      onPrimaryAction={onclick}
      localization={{
        title: getLocalizedText('countryNotSupported-page.title'),
        primaryText: getLocalizedText('countryNotSupported-page.backButton'),
      }}
    >
      <BodyText className="body__text">
        {getLocalizedText('countryNotSupported-page.bodyText')}
      </BodyText>
    </PageMessage>
  )
}

export default CountryNotSupportedPage
